module.exports = __webpack_public_path__ + "static/mobile_text-4653f0c720c6e59443cc71e214384c36.jpg";